export const STEP_INTRODUCE = 0;
export const STEP_STYLE = 1;
export const STEP_WELCOME = 2;
export const STEP_AVAILABILITY = 3;
export const STEP_CHANNELS = 4;
export const STEP_QUALIFY = 5;
export const STEP_LIVE = 6;
